import React, { Component } from 'react';
import { Icon, Row } from 'antd';
import './App.css';

import GlobalSituation from './components/GlobalSituation/GlobalSituation'
import CountrySituation from './components/CountrySituation/CountrySituation'
import BelgianSituation from './components/BelgianSituation/BelgianSituation'
import Pills from './components/charts/Pills/PillsComponent'
import jetpackLogo from './assets/images/JetpackAI-small.png'
import medorLogo from './assets/images/ckbbaeplcepnomib.png'
import fondsLogo from './assets/images/fondsPourLeJournalism.png'
import Share from './components/Share/Share'

/*const styles = {
  step: {
    fontFamily: 'Open Sans', 
    color: 'lightgrey',
    margin: '1rem 2rem 1rem 2rem',
    paddingTop: 50,
    width: '70%',
    pointerEvents: 'none',
  },
  p: {
    fontSize: 35, 
    fontFamily: 'career', 
    borderLeftWidth: '5px',
    borderLeftColor: '#e2e2e2',
    borderLeftStyle: 'solid',
    padding: '16px'
  },
  quoted: {
    color: 'lightgrey',
    borderLeftWidth: '5px',
    borderLeftColor: '#e2e2e2',
    borderLeftStyle: 'solid',
    paddingLeft: '16px',
    paddingBottom: '16px'
  },
  insideStyles: {
    background: "#ffffffdd",
    padding: 20,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)"
  }
};*/

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { width: 0, height: 0 };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
  }
  
  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  render() {
    const { width, height} = this.state
    return (
      <div>
        {height &&
        <div>
          <div style={{ position: 'relative' }}>
            <div style={{ position: 'absolute', top: 150, right: 15, fontFamily: 'career'}}>With the support of <img alt="MedorLogo" style={{height: 35, marginTop: -5, marginLeft: 4, marginRight: 8}} src={fondsLogo}/></div>
            <div style={{height: '100vh', width: '100vw', position: 'absolute', zIndex: -1}}>
              <Pills />
            </div>
            <div style={{height: '100vh', width: '100vw', textAlign: 'center', paddingTop: width < 900 ? 160 : 0 }}>
              <div style={{ paddingTop: width < 900 ? '25vh' : '35vh', fontFamily: 'career', lineHeight: 1.2, color: 'black'}}>
                <div style={{fontSize: width < 900 ? 50 : 80 }}>The pain of Belgians</div>
                <div style={{fontSize: width < 900 ? 15 : 20, marginTop: 30, marginBottom: 15 }}>Investigation by <a target="_blank" rel="noopener noreferrer" href="http://medor.coop"><img alt="MedorLogo" style={{height: 25, marginTop: -10, marginLeft: 8, marginRight: 8}} src={medorLogo}/></a> {width < 900 ? <br/> : null } and data visualization by <a target="_blank" rel="noopener noreferrer" href="http://jetpack.ai"><img style={{height: 30, marginLeft: 8}} alt="JetpackLogo" src={jetpackLogo}/></a></div>
                <div style={{fontSize: width < 900 ? 15 : 20 }}>September 2019</div>
              </div>
              <div style={{textAlign: 'center', marginTop: '10vh'}}>
                <div>Scroll</div>
                <div><Icon style={{ marginTop: 8, fontSize: '32px', color: 'black' }} type="down-circle" /></div>
              </div> 
            </div>
          </div>
          <div>
            <div style={{ width: width < 900 ? '80%' : '60%', margin: 'auto', marginTop: 100, marginBottom: 100, color: 'black', fontSize: width < 900 ? 18 : 24, fontFamily: 'career' }} className="subhead">
              The USA is experiencing a considerable health crisis. Over-prescription of painkillers causes millions of addictions and thousands of deaths. Belgium is preserved. Are we sure? More than a million Belgians consumed a form of opioid in 2017. Contramal (tramadol), Oxycontin (oxycodone) or Durogesic (fentanyl), does that ring a bell? Here is the map of Belgium’s pain. 
              <Row type="flex" justify="end" ><Share /></Row>
            </div>
            {width < 900 && <div style={{ width: '80%', margin: 'auto', marginTop: 70, marginBottom: 20, color: 'black', fontSize: 18, fontFamily: 'career', backgroundColor: '#d3d3c830', padding: 16 }}> 
              <Row type="flex" justify="start">
                <div style={{ margin: 'auto' }}><Icon type="warning" style={{ fontSize: 48, color: '#ffb60a' }} /></div>
                <div>This article is optimized for desktop screens. We therefore suggest you to read this piece on your computer and not on your mobile.</div>
              </Row>  
              </div>
            }
          </div>
          <GlobalSituation />
          <div style={{ marginTop: '20vh'}}></div>
          <CountrySituation />
          <div style={{ marginTop: '20vh'}}></div>
          <BelgianSituation />
          <div style={{ paddingTop: width < 900 ? '25vh' : '35vh', fontFamily: 'career', lineHeight: 1.2, color: 'black'}}>
            <div style={{fontSize: width < 900 ? 15 : 20, width: '60vw', margin: 'auto' }}>
              Authors: Olivier Billy (text) & Karim Douieb (data visualization). <br/><br/><br/>
              Find out more about this subject within our special series of articles: <a target="_blank" rel="noopener noreferrer" href="https://medor.coop/nos-series/la-douleur-des-belges/">"The pain of Belgians"</a>.
              {/*<Row type="flex" justify="end" ><Share /></Row>*/}
            </div>
          </div>
        </div>
      }
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js